import { doHttp } from '../utils/common'
import { HTTP_TYPE_GET, HTTP_TYPE_POST } from '../utils/config'

/**
 * 获取商品饲喂阶段选择列表
 * @return {*}
 */
export function apiFeedStage () {
  return doHttp('/master/product/feedStage.action', HTTP_TYPE_GET)
}

/**
 * 获取商品通用名选择列表
 * @return {*}
 */
export function apiSortName () {
  return doHttp('/master/product/sortName.action', HTTP_TYPE_GET)
}

/**
 * 获取商品配料类型选择列表
 * @return {*}
 */
export function apiType () {
  return doHttp('/master/productIngredients/type.action', HTTP_TYPE_GET)
}

/**
 * 获取素材类型列表
 * @return {*}
 */
export function apiLibrary () {
  return doHttp('/master/library.action', HTTP_TYPE_GET)
}

/**
 * 获取生产班次
 */
 export function apiBatch () {
  return doHttp('/master/batch.action', HTTP_TYPE_GET)
}
